import { render } from "./App.vue?vue&type=template&id=463c2d52"
const script = {}

import "./App.vue?vue&type=style&index=0&id=463c2d52&lang=css"

import exportComponent from "D:\\code\\vue practice\\vue mastery\\real world vue 3\\7. Deploying with Render\\deploying-with-render\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__